import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ReactNode } from "react";
import { queryClient } from "./queryClient";

interface QueryProviderProps {
  children: ReactNode;
}

/**
 * QueryProvider
 *
 * Wraps the app with TanStack Query's QueryClientProvider.
 * Includes React Query Devtools in development mode.
 */
export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
